import React from "react";
import { Stack, Text } from "@origin-digital/ods-core";
import ContactField from "./FormComponents/ContactField";
import HomeUserSiteSupervisorInternet from "./HomeUser/HomeUserSiteSupervisorInternet";
import HomeUserPreInstaller from "./HomeUser/HomeUserPreInstaller";
import FormFieldLayout from "./FormComponents/FormFieldLayout";

const InternetPreInstallBlock = (props: { homeUser: boolean }) => {
  const preInstallerHelperText = (
    <Stack>
      <Text variant="body-small" tone="neutralLight">
        When pre-installer details are provided, update statuses for the
        pre-installation request will not appear in Origin Connect, as the
        request is assigned directly to the pre-installer. Please contact your
        pre-installer for any updates.
      </Text>
      <Text variant="body-small" tone="neutralLight">
        In this instance, we request you to inform Origin once the
        pre-installation is completed so we can continue processing your
        internet request.
      </Text>
    </Stack>
  );
  return (
    <Stack
      space={{
        xs: "xlarge",
        md: "xxlarge",
      }}
    >
      {props.homeUser ? (
        <HomeUserPreInstaller text={preInstallerHelperText} />
      ) : (
        <FormFieldLayout text={preInstallerHelperText}>
          <ContactField
            contactType="INTERNET_PREINSTALLER"
            name="internetPreInstaller"
            label="Pre-installer (Optional)"
          />
        </FormFieldLayout>
      )}
      {props.homeUser ? (
        <HomeUserSiteSupervisorInternet />
      ) : (
        <FormFieldLayout>
          <ContactField
            contactType="SUPERVISOR"
            name="internetSiteSupervisor"
            label="Site supervisor"
          />
        </FormFieldLayout>
      )}
    </Stack>
  );
};

export default InternetPreInstallBlock;
